import PollsQuestionAndOptions from "./PollQuestionAndOptions";
export default PollsQuestionAndOptions;
